// extracted by mini-css-extract-plugin
export default {"failText":"no-payment-flow-module__failText___BPaPh","retryButton":"no-payment-flow-module__retryButton___p9q4h"};